<span fxLayout="row" fxFlex="100" fxLayoutAlign="center start">
  <span fxLayout="column" class="position-relative lane-body" fxFlex="0 1 900px" fxFlex.xs="100" fxFlex.sm="100">
    @if (!loading && swimlane.items && swimlane.items.length > 0) {
    <span>
      <span fxLayout="column" class="res-pad-lr-0-20 carousel-fix-width w-100" fxLayoutGap="10px">
        @for (item of swimlane.items; track $index) {
        <span fxLayout="column" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
          <span class="dekstop-row-mobile-column" fxFlex="100"
            style="cursor: pointer;" (click)="open(generatelinks(item))">

            <!-- SINGLE TITLE (Positioned via Grid) -->
            <h2 class="mat-headline-2 mb5px item-title">{{item.title}}</h2>

            <!-- Kachel -->
            <span class="mb-1 carousel-card">
              <span class="h-100 position-relative overflow-hidden" fxLayout="row">
                <!-- Desktop Image -->
                @if (isTopListeTopListe) {
                  <img [src]="item.imagehigh ? (item.imagehigh | safe: 'resourceUrl') : PLACEHOLDER_IMAGE_WITH_PATH"
                    class="carousel-card-image desktop-only" style="z-index: 1;"
                    [alt]="item.title + ' - ' + 'extra.image' | translate" (load)="imageLoaded[item.id] = true"
                    [class.loaded]="imageLoaded[item.id]" (error)="onImageError($event)" fetchpriority="low"
                    loading="lazy">
                } @else {
                  <img [src]="item.imagelow ? (item.imagelow | safe: 'resourceUrl') : PLACEHOLDER_IMAGE_WITH_PATH"
                    class="carousel-card-image desktop-only" style="z-index: 1;"
                    [alt]="item.title + ' - ' + 'extra.image' | translate" (load)="imageLoaded[item.id] = true"
                    [class.loaded]="imageLoaded[item.id]" (error)="onImageError($event)" fetchpriority="low"
                    loading="lazy">
                }
                <!-- Mobile Image -->
                <img [src]="item.imagehigh ? (item.imagehigh | safe: 'resourceUrl') : PLACEHOLDER_IMAGE_WITH_PATH"
                  class="carousel-card-image mobile-only" style="z-index: 1;"
                  [alt]="item.title + ' - ' + 'extra.image' | translate" (load)="imageLoaded[item.id] = true"
                  [class.loaded]="imageLoaded[item.id]" (error)="onImageError($event)" fetchpriority="low"
                  loading="lazy">
                @if (item.itemclass !== sic.Redtext && item.itemclass !== sic.Special) {
                <span class="overlay-shade position-absolute overfill zero-pos">
                  <span fxLayout="column" fxLayoutAlign="end" class="h-100 padding-badges">
                    @if (item.itemclass === sic.Besprechung || item.itemclass === sic.Ytbesprechung) {
                    <span fxLayout="row" fxLayoutGap="6" fxLayoutAlign="end end">
                      @if (item.rating === 4) {
                      <img style="padding-bottom: 4px;" class="image-size-35x35 p4px"
                        [alt]="'searchList.selectors.ratingOptions.4' | translate" src="assets/media/rating_badge.svg">
                      }
                      @if (item.itemclass === sic.Ytbesprechung) {
                      <img [alt]="'extra.socialmedia' | translate" class="image-size-35x35"
                        src="assets/media/ico_socialmedia.svg">
                      }
                      @if (item.altersfreigabe && item.rating > 2) {
                      <app-age-category-badge class="image-size-35x35"
                        [ageCategory]="item.altersfreigabe"></app-age-category-badge>
                      }
                      <app-traffic-lights class="image-size-18x46" [rating]="item.rating"></app-traffic-lights>
                    </span>
                    }
                  </span>
                </span>
                }
              </span>
            </span>

            <span fxLayout="column" class="item-content">
              
              @if (item.itemclass === sic.Besprechung || item.itemclass === sic.Ytbesprechung) {
                <!-- Overline Info (Desktop only) -->
                <span class="desktop-only">
                  <span>
                    {{item.genre}},
                    {{$any(item).runtime ? $any(item).runtime / 60 + ' Minuten, ' : ''}}
                    {{getAlterText(item.altersfreigabe) | translate}} Jahren
                  </span>
                </span>
                <!-- Flimmo Meint -->
                <span class="mb1 title-content-gap">
                  <span class="primary-color mat-headline-1 center-h1" style="padding-right: 10px;">FLIMMO meint</span>
                  {{item.paed}}
                </span>
              }
              @if (item.itemclass === sic.Redtext || item.itemclass === sic.Special) {
                <div class="mb1">
                  {{getKachelText(item.id, item.unterschrift_kachel)}}
                </div>
              }

              <!-- Mehr Info Button -->
              <span fxFlex="20px" class="mobile-only"></span>
              <span style="margin-top: auto; ">
                <button
                  class="align-items-center justify-content-center flimmo-outline-button f-button-label text-decoration-none black"
                  (click)="open(generatelinks(item))">Mehr Infos</button>
              </span>
            </span>
          </span>
          <span fxFlex="40px"></span>
        </span>
        }
      </span>
    </span>
    }
  </span>
</span>